// Typelizer digest c9a333bc78d626d0511cd651e313561b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** GET /c/:company_id/ledger/vat_return/declaration */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/vat_return/declaration', {}, options),
    method: 'get',
  }),
}
